import * as React from 'react';
import { DashboardToolbar as DashboardToolbarUI } from '../../../../components/Dashboard';
export class PanelDashboard extends React.Component {
    render() {
        const { headerText, showConfigureButton, showCloseButton, onConfigure, onClose, accessLevel, children, } = this.props;
        return (React.createElement(DashboardToolbarUI, { title: headerText, onConfigure: onConfigure, showConfigure: showConfigureButton, showClose: showCloseButton, onClose: onClose, accessLevel: accessLevel }, children));
    }
}
PanelDashboard.defaultProps = {
    showConfigureButton: true,
    showCloseButton: true,
    headerText: 'Module',
    onClose: null,
    onConfigure: null,
    accessLevel: 'Full',
};
